import {Separator} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import {Fragment, useMemo} from 'react';

import {TestIdProps} from 'shared/web';

import {Flag} from '../../../../../components/Flag/Flag';
import i18n from '../../../../../i18n/i18n';
import {EquipmentScoreType} from '../../../../../types/MarketType';
import {getEquipmentCategories} from '../utils/getEquipmentCategories';
import {EqupimentCategory} from './EqupimentCategory';

interface EquipmentProps extends TestIdProps {
  equipmentScore?: EquipmentScoreType;
}

export function Equipment(props: EquipmentProps) {
  const {equipmentScore} = props;

  const equipmentCategories = useMemo(
    () => getEquipmentCategories(equipmentScore),
    [equipmentScore]
  );

  return (
    <VStack spacing={6}>
      <HStack align="center" justify="center" spacing={2} wrap>
        <Text size="xSmall" color="secondary">
          {i18n.t('entity.overviewEquipment.labels.legend')}:
        </Text>
        <Flag
          backgroundColor="palettes.blue.30.100"
          color="palettes.blue.80.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.availableHighlightFeature')}
        />
        <Flag
          backgroundColor="palettes.blue.10.100"
          color="palettes.blue.80.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.availableFeature')}
        />
        <Flag
          backgroundColor="palettes.red.30.100"
          color="palettes.red.90.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.missingHighlightFeature')}
        />
        <Flag
          backgroundColor="palettes.red.10.100"
          color="palettes.red.80.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.missingFeature')}
        />
      </HStack>
      <VStack>
        {equipmentCategories.map((category, index) => (
          <Fragment key={`${category.minShare ?? 'min'}-${category.maxShare ?? 'max'}`}>
            {index > 0 && <Separator orientation="horizontal" spacing={4} />}
            <EqupimentCategory
              flags={category.flags}
              minShare={category.minShare}
              maxShare={category.maxShare}
              data-testid={props['data-testid']}
            />
          </Fragment>
        ))}
      </VStack>
    </VStack>
  );
}
